import request from "./request";

// 获取商城资源网页信息
export function getShopResourceHtmlById(params: number) {
  return request({
    url: "/website/api/resource/detail/" + params,
    method: "get"
  });
}
